import { Directive } from 'vue'
export const clickOutside: Directive = {
  beforeMount(el, binding) {
    // 全てのClickをListenする
    document.addEventListener('click', (event) => {
      // NOTE:
      // 押した瞬間に呼び出し側がoutsideと見做されて発火するのを防ぐために
      // 以下のように呼び出し側とDirective側で共通のキーを持たせて
      // 発火しないようにする。
      // @example
      // 呼び出し側
      // <button
      //  @click="showForm"
      //  click-outside-prevent="form"
      // >show</button>
      // Directive側
      // <form v-click-outside:form></form>
      if (binding.arg) {
        const target = event.target as any
        const preventAttr = (target.attributes as any)['click-outside-prevent']
          ?.value

        // click-outside-prevent要素を直接クリックした場合
        if (binding.arg === preventAttr) {
          return
        }

        // 子要素をクリックした場合
        const parent = document.querySelector(
          `[click-outside-prevent=${binding.arg}]`
        )
        if (parent && parent.contains(target)) {
          return
        }
      }
      if (!el.contains(event.target)) {
        // クリックした要素がv-outside-clickの要素もしくはその子要素ではない場合callbackを発火する
        binding.value(event)
      }
    })
  },
  unmounted(el, binding) {
    // FIXME: 関数共通化したいけどやり方わからん
    // あとこれでほんまにremoveできてるのかも怪しい
    document.removeEventListener('click', (event) => {
      if (!el.contains(event.target)) {
        binding.value(event)
      }
    })
  }
}
